export default __webpack_public_path__ + "static/rbbg-cbe7d4e2e16777a4507588d208cd09ff.jpg";